<template>
  <div>
    <v-card>
      <p class="ma-0 pl-2 py-2">Porcentaje de Checklist completados</p>
      <v-divider></v-divider>
      <v-container>
        <div class="d-flex justify-center" v-if="loadingAverage">
          <v-progress-circular
            indeterminate
            size="50"
            color="primary"
          ></v-progress-circular>
        </div>
        <v-row>
          <v-col class="pb-0" cols="6"></v-col>
          <v-col class="pb-0 text-center" cols="3">Completados</v-col>
          <v-col class="pb-0 text-center" cols="3">Faltantes</v-col>
        </v-row>
        <v-row v-for="(status, index) in averageData" :key="index">
          <v-col cols="6">{{ status.title }}</v-col>
          <v-col cols="3" class="text-center"
            >{{ status.completed }} /
            <span class="green--text"
              >{{ status.averageCompleted }}%</span
            ></v-col
          >
          <v-col cols="3" class="text-center error--text">{{
            status.total
          }}</v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import { errorMessage } from "@/services/MessageService";
import { database } from "@/config/firebase";
export default {
  data() {
    return {
      loadingAverage: false,
      analyticsRef: null,
      averageData: []
    };
  },
  async mounted() {
    this.getAnalyticsAverage();
  },
  methods: {
    getAnalyticsAverage() {
      try {
        this.loadingAverage = true;
        this.analyticsRef = database("analytics/checklistStatus");
        this.analyticsRef.on("value", snapshot => {
          if (snapshot.exists()) {
            this.averageData = [];
            const generalData = snapshot.val();
            if (generalData) {
              for (const status in generalData) {
                if (Object.hasOwnProperty.call(generalData, status)) {
                  const statusData = generalData[status];
                  let averageCompleted = 0;
                  if (statusData.completed != 0)
                    averageCompleted = (
                      (statusData.completed * 100) /
                      statusData.total
                    ).toFixed(1);
                  switch (status) {
                    case "deliveryInput":
                      this.averageData.push({
                        title: "ENTREGAS (E)",
                        averageCompleted,
                        total: statusData.total - statusData.completed,
                        completed: statusData.completed
                      });
                      break;
                    case "deliveryOutput":
                      this.averageData.push({
                        title: "ENTREGAS (S)",
                        averageCompleted,
                        total: statusData.total - statusData.completed,
                        completed: statusData.completed
                      });
                      break;
                    case "maintenanceInput":
                      this.averageData.push({
                        title: "MANTENIMIENTO (E)",
                        averageCompleted,
                        total: statusData.total - statusData.completed,
                        completed: statusData.completed
                      });
                      break;
                    case "maintenanceOutput":
                      this.averageData.push({
                        title: "MANTENIMIENTO (S)",
                        averageCompleted,
                        total: statusData.total - statusData.completed,
                        completed: statusData.completed
                      });
                      break;
                    case "recollectionInput":
                      this.averageData.push({
                        title: "RECOLECCIÓN (E)",
                        averageCompleted,
                        total: statusData.total - statusData.completed,
                        completed: statusData.completed
                      });
                      break;
                    case "recollectionOutput":
                      this.averageData.push({
                        title: "RECOLECCIÓN (S)",
                        averageCompleted,
                        total: statusData.total - statusData.completed,
                        completed: statusData.completed
                      });
                      break;
                    case "relocationInput":
                      this.averageData.push({
                        title: "REUBICACIÓN (E)",
                        averageCompleted,
                        total: statusData.total - statusData.completed,
                        completed: statusData.completed
                      });
                      break;
                    case "relocationOutput":
                      this.averageData.push({
                        title: "REUBICACIÓN (S)",
                        averageCompleted,
                        total: statusData.total - statusData.completed,
                        completed: statusData.completed
                      });
                      break;
                    case "rentedServiceInput":
                      this.averageData.push({
                        title: "RENTADO SERVICIO (E)",
                        averageCompleted,
                        total: statusData.total - statusData.completed,
                        completed: statusData.completed
                      });
                      break;
                    case "rentedServiceOutput":
                      this.averageData.push({
                        title: "RENTADO SERVICIO (S)",
                        averageCompleted,
                        total: statusData.total - statusData.completed,
                        completed: statusData.completed
                      });
                      break;
                    case "transferInput":
                      this.averageData.push({
                        title: "TRASPASOS (E)",
                        averageCompleted,
                        total: statusData.total - statusData.completed,
                        completed: statusData.completed
                      });
                      break;
                    case "transferOutput":
                      this.averageData.push({
                        title: "TRASPASOS (S)",
                        averageCompleted,
                        total: statusData.total - statusData.completed,
                        completed: statusData.completed
                      });
                      break;
                  }
                }
              }
              this.loadingAverage = false;
            }
          } else {
            this.loadingAverage = false;
          }
        });
      } catch (error) {
        errorMessage(
          "Ha ocurrido un error inesperado al consultar los analiticos"
        );
      }
    }
  },
  beforeDestroy() {
    // :: Detach databaseRef listener
    this.analyticsRef.off("value");
    this.analyticsRef = null;
  }
};
</script>

<style>
.text-analytics {
  font-size: 70px !important;
}
.v-text-field > .v-input__control > .v-input__slot:before {
  border-style: unset;
}
.v-overflow-btn .v-input__control::before {
  height: 0px;
}
</style>
